import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, InfoPanel, Separator } from "@nju/ui";

export function PayByLinkTechnicalError() {
  return (
    <>
      <Separator size="m" tone="invisible" />
      <InfoPanel
        description="Spokojnie, to nie problem. Kontynuuj i dodaj środki później."
        icon="undo"
        title="dodanie środków nie jest teraz możliwe"
      >
        <Link href={portalRoutes.terminInstalacji.get()} passHref={true}>
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            dalej
          </A>
        </Link>
      </InfoPanel>
      <Separator size="l" tone="invisible" />
    </>
  );
}
